import { AuthContainer, AppContainer } from '@/components/containers';
import { Outlet } from 'react-router-dom';

function App() {
  return (
    <AuthContainer>
      <AppContainer>
        <Outlet />
      </AppContainer>
    </AuthContainer>
  );
}

export default App;
